import { ExpandMoreOutlined } from "@mui/icons-material";
import { Collapse, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import AssetAndChildrenList, { AssetAndChildrenListProps } from "./asset-and-children-list";
import RotatableBox from "./rotatable-box";

type AssetAndChildrenAccordionProps = AssetAndChildrenListProps & {
  nbToShow: number;
};

const AssetAndChildrenAccordion = (props: AssetAndChildrenAccordionProps) => {
  const { t } = useTranslation();
  const { assets, nbToShow, ...listProps } = props;

  const [expanded, setExpanded] = React.useState(false);

  return (
    <Stack spacing={0.5}>
      <AssetAndChildrenList assets={assets.slice(0, nbToShow)} {...listProps} />
      {assets.length > nbToShow && (
        <Stack>
          <Collapse in={expanded} sx={{ padding: 0, margin: 0 }}>
            <AssetAndChildrenList assets={assets.slice(nbToShow)} {...listProps} />
          </Collapse>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ cursor: "pointer" }}
            onClick={() => setExpanded(!expanded)}
          >
            <Typography color="primary">
              + {assets.length - nbToShow} {t("common:lowerCaseMore")}
            </Typography>
            <RotatableBox rotated={expanded} from={0} to={180}>
              <ExpandMoreOutlined color="primary" />
            </RotatableBox>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default AssetAndChildrenAccordion;
